export default {
  rotate: (degrees) => {
    return {
      transition: '0.3s',
      transform: `rotate(${degrees}deg)`
    }
  }
}
